var exports = {
  "g": "BaseCell__zW5e1L",
};

module.exports = exports;
